import * as React from 'react';
import { Button, notification } from 'antd';
import { ExpenseService } from '../../../service/ExpenseService';
import {
  ExpenseObject,
  ExpenseErrorObject,
  ExpenseNode,
  ExpenseError,
} from './constants';
import { ExpenseForm } from './ExpenseForm';
import { forEach } from 'lodash';

export class AddExpense extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expense: props.expense || JSON.parse(JSON.stringify(ExpenseObject)),
      error: { ...ExpenseErrorObject },
      buttonDisabled: false,
    };
  }

  expenseService = new ExpenseService();

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      expense: nextProps.expense || JSON.parse(JSON.stringify(ExpenseObject)),
    });
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const expense = { ...this.state.expense };
    expense[e.target.name] = e.target.value;
    this.setState({ expense });
  };

  checkError = () => {
    const error = { ...this.state.error };
    let isError = false;
    const requiredFields = ['head'];
    forEach(this.state.expense, (value, key) => {
      if (
        typeof value === 'string' &&
        requiredFields.indexOf(key) > -1 &&
        !value.trim()
      ) {
        isError = true;
        error[key] = `This is a Required field`;
      } else if (!value && requiredFields.indexOf(key) > -1) {
        isError = true;
        error[key] = `This is a Required field`;
      } else if (requiredFields.indexOf(key) > -1) {
        error[key] = '';
      }
    });
    this.setState({ error });
    return isError;
  };

  saveVendor = () => {
    if (this.checkError()) {
      return;
    }
    this.setState({ buttonDisabled: true });
    this.expenseService?.addExpense(
      this.state.expense,
      (response) => {
        this.setState({ buttonDisabled: false });
        notification.success({
          message: 'Expense ' + (this.state.expense.id ? 'Updated' : 'Added'),
          description: `Expense named ${
            this.state.expense.head
          } was successfuly ${this.state.expense.id ? 'Updated' : 'Added'}`,
        });
        this.props.handleTabChange?.('1');
      },
      (error) =>
        notification.error({
          message:
            'Expense ' + (this.state.expense.id ? 'Update Error' : 'Add Error'),
          description: JSON.stringify(error),
        }),
    );
  };

  clear = () => {
    this.setState({
      expense: JSON.parse(JSON.stringify(ExpenseObject)),
      error: { ...ExpenseErrorObject },
    });
  };

  render() {
    return (
      <div>
        <ExpenseForm
          value={this.state.expense}
          error={this.state.error}
          onChange={this.onChange}
        />
        <Button
          type="dashed"
          onClick={this.clear}
          children="Clear"
          style={{ width: '50%' }}
        />
        <Button
          type="primary"
          onClick={this.saveVendor}
          children="Submit"
          style={{ width: '50%' }}
          disabled={this.state.buttonDisabled}
        />
      </div>
    );
  }
}

interface Props {
  expense?: ExpenseNode;
  handleTabChange?: (key) => void;
}

interface State {
  expense: ExpenseNode;
  error: ExpenseError;
  buttonDisabled: boolean;
}
